import { Box, Button, Card, CardBody, CardHeader, Spinner, Text } from "grommet"
import { FormView, Hide, SettingsOption } from "grommet-icons"
import { useEffect, useState } from "react"
import { usePartialUpdateRouletteCategoryMutation } from "../../api/rouletteWidgetApi"
import { useTranslation } from "react-i18next"

const rarityOptions = {
    500: {
        name: 'Common',
        color: '#fdfefe'
    },
    250: {
        name: 'Uncommon',
        color: '#2fde78'
    },
    160: {
        name: 'Rare',
        color: '#385ef5'
    },
    70: {
        name: 'Epic',
        color: '#a14ac7'
    },
    15: {
        name: 'Legendary',
        color: '#f1c40f'
    },
    7: {
        name: 'Methyc',
        color: '#D35400'
    },
    1: {
        name: 'Relic',
        color: '#c70404'
    }
}

export const RouletteItem = ({ item, dropChance, onSettingsClick, onHideClick }) => {
    const { t, ready } = useTranslation('roulette', { useSuspense: false });
    const [isHideButtonDisplayed, setHideButtonDisplayed] = useState(item.hidden);

    const handleHide = (value) => {
        setHideButtonDisplayed(value);
        onHideClick({ item, hide: value });
    }

    const handleSettings = () => {
        onSettingsClick(item);
    }

    if (!ready) {
        return (<Spinner/>)
    }

    if (ready) {
        return (
            <Card key={item.id} style={{ opacity: isHideButtonDisplayed ? 0.3 : 1 }}>
                <CardHeader justify="end" gap="small" pad={{top: 'medium', left: 'medium', right: 'medium', bottom: 'none'}}>
                    <Box fill="horizontal">
                        <Text weight={800}>{item.categoryName}</Text>
                    </Box>
                    <Button size="medium" icon={isHideButtonDisplayed ? <Hide/> : <FormView/>} onClick={() => handleHide(!isHideButtonDisplayed)}/>
                    <Button size="medium" icon={<SettingsOption/>} onClick={handleSettings}/>
                </CardHeader>
                <CardBody fill={false} pad={{top: 'small', left: 'medium', right: 'medium', bottom: 'medium'}}>
                    <Box direction="column" align="center" gap="small">
                        <Box fill="horizontal">
                            <Text weight={500} size="14px" color={'gray'}>{t('rewardNames')}</Text>
                            <Text>{item.rewardNames}</Text>
                        </Box>
                        <Box fill="horizontal">
                            <Text weight={500} size="14px" color={'gray'}>{t('rarity')}</Text>
                            <Text color={rarityOptions[item.rarity].color}>{rarityOptions[item.rarity].name}</Text>
                        </Box>
                        <Box fill="horizontal">
                            <Text weight={500} size="14px" color={'gray'}>{t('dropChance')}</Text>
                            <Text>{item.hidden ? 0 : dropChance}%</Text>
                        </Box>
                    </Box>
                </CardBody>
            </Card>
        )
    }
}